export enum ConceptCreationOptions {
    New = 'new',
    FullyImport = 'fullyImport',
    PartialImport = 'partialImport',
    Reference = 'reference',
}
